<template>
  <div
    v-show="showFooterBar"
    id="fixedbottom"
    class="fixed-button-custom btn-tab-group"
  >
    <custom-h-r class="mt-0" variant="success" />
    <div class="col-12 mb-3">
      <div class="container-foot d-flex justify-content-end">
        <action-button
          i="fas fa-save"
          type="submit"
          variant="success"
          @click="save"
        >
          Guardar
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomHR from '@/components/common/page/CustomHR';
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'FixedBottomSaveButton',
  components: {
    CustomHR,
    ActionButton,
  },
  props: {
    offset: {
      type: Number,
      default: () => 250,
    },
  },
  data() {
    return {
      showFooterBar: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    save() {
      this.$emit('click');
    },
    handleScroll() {
      let currentScrollPos = window.pageYOffset;
      this.showFooterBar = this.offset <= currentScrollPos;
      this.prevScrollpos = currentScrollPos;
    },
  },
};
</script>

<style scoped>
#fixedbottom {
  background-color: #fff;
}

.fixed-button-custom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 118px;
  z-index: 1030;
}
</style>
